module.exports = __webpack_public_path__ + "media/images/help/step4-extra-e6c054b1168d52afa9dc544a92a50ac2.png";